import { createContext } from "react";
import PrivateUser from "../dtos/user";

export type AuthContextType = [
  PrivateUser | null,
  React.Dispatch<React.SetStateAction<PrivateUser | null>>
];

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export default AuthContext;
